// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"c239ea0e","206":"1891e8b4","514":"aacbf233","611":"03782aa3","857":"f86f54a1","977":"1c529b57"}[chunkId] + ".chunk.js";
};